import { environment as defaultEnvironment } from './environment.defaults';
export const environment = {
  ...defaultEnvironment,
  production: true,
  apiPath: 'https://gpfj-api.goldsoftng.com/',
  apiDomain: 'gpfj-api.goldsoftng.com/',
  log: false,
  flags: {
    useNewHeader: false
 }
};